import React, { useState } from 'react';
// import { APP_KEY, API_URL } from './../config';
// import { getToken } from './../Utils/Common';
import { useHistory } from "react-router-dom";
import 'bootstrap-daterangepicker/daterangepicker.css';

function DistributorDashboard(props) {
  const history = useHistory();
  const [showAlert, setShowAlert] = useState(false);

  const handleOnboardClick = () => {
    setShowAlert(true);
  };

  const handleConfirm = () => {
    setShowAlert(false);
    history.push({ pathname: "/create-users" });
  };

  const handleCancel = () => {
    setShowAlert(false);
  };

  return (
    <>
      <div>
        <div className="content pt-5 pb-5">
          <div className="container-fluid">
            <div className="card card-body">
              {/* <div className='dashboard-header font-merriweather'>
                TODAY SALES
              </div> */}
              <div className="row">
                <div className="col-sm-6 col-md-4 col-lg-3 mt-50" onClick={handleOnboardClick}>
                  <div className='dbox-outer'>
                    <div className='dbox-cols'>
                      {/* <div className='pr-2 dbox-icon'><img src='../images/aeps-logo-2.svg' alt='icon' /></div> */}
                      <div className='dbox-text2 font14'>
                        Onboard Partner
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-6 col-md-4 col-lg-3 mt-50" onClick={() => history.push({ pathname: "/myledger" })}>
                  <div className='dbox-outer'>
                    <div className='dbox-cols'>
                      {/* <div className='pr-2 dbox-icon'><img src='../images/payment-gateway.svg' alt='icon' /></div> */}
                      <div className='dbox-text2 font14'>
                        Ledger
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-6 col-md-4 col-lg-3 mt-50" onClick={() => history.push({ pathname: "/request-money-list" })}>
                  <div className='dbox-outer'>
                    <div className='dbox-cols'>
                      {/* <div className='pr-2 dbox-icon'><img src='../images/recharge-icon.svg' alt='icon' /></div> */}
                      <div className='dbox-text2 font14'>
                        Agent Request
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3 mt-50" onClick={() => history.push({ pathname: "/payment-deposit-list" })}>
                  <div className='dbox-outer'>
                    <div className='dbox-cols'>
                      {/* <div className='pr-2 dbox-icon'><img src='../images/matm-icon.svg' alt='icon' /></div> */}
                      <div className='dbox-text2 font14'>
                        Agent Payment
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3 mt-50" onClick={() => history.push({ pathname: "/cod-request-list" })}>
                  <div className='dbox-outer'>
                    <div className='dbox-cols'>
                      {/* <div className='pr-2 dbox-icon'><img src='../images/upiqr-icon.svg' alt='icon' /></div> */}
                      <div className='dbox-text2 font14'>
                        Agent COD Request
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3 mt-50" onClick={() => history.push({ pathname: "/channel-wallet-ledger" })}>
                  <div className='dbox-outer'>
                    <div className='dbox-cols'>
                      {/* <div className='pr-2 dbox-icon'><img src='../images/money-icon.svg' alt='icon' /></div> */}
                      <div className='dbox-text2 font14'>
                        Channel Khata-book
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-6 col-md-4 col-lg-3 mt-50" onClick={() => history.push({ pathname: "/request-money" })}>
                  <div className='dbox-outer'>
                    <div className='dbox-cols'>
                      {/* <div className='pr-2 dbox-icon'><img src='../images/money-icon.svg' alt='icon' /></div> */}
                      <div className='dbox-text2 font14'>
                        Request Money
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3 mt-50" onClick={() => history.push({ pathname: "/payment-deposit" })}>
                  <div className='dbox-outer'>
                    <div className='dbox-cols'>
                      {/* <div className='pr-2 dbox-icon'><img src='../images/payment-gateway.svg' alt='icon' /></div> */}
                      <div className='dbox-text2 font14'>
                        Payment Deposit
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-6 col-md-4 col-lg-3 mt-50" onClick={() => history.push({ pathname: "/manage-users" })}>
                  <div className='dbox-outer'>
                    <div className='dbox-cols'>
                      {/* <div className='pr-2 dbox-icon'><img src='../images/money-icon.svg' alt='icon' /></div> */}
                      <div className='dbox-text2 font14'>
                        Manage User
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3 mt-50" onClick={() => history.push({ pathname: "/user-access-management" })}>
                  <div className='dbox-outer'>
                    <div className='dbox-cols'>
                      {/* <div className='pr-2 dbox-icon'><img src='../images/money-icon.svg' alt='icon' /></div> */}
                      <div className='dbox-text2 font14'>
                        User Access Management
                      </div>
                    </div>
                  </div>
                </div>

              </div>




              {/* <hr /> */}

              {/* <div className='date-search'>
                <div className='row'>
                  <div className='col-sm-3 col-lg-2'>
                    <div class="form-group">
                      <label className='date-search-label mb-0 text-blue'>From</label>
                      <input type="text" class="form-control form-control-border" placeholder="27 September 2022" />
                    </div>
                  </div>
                  <div className='col-sm-3 col-lg-2'>
                    <div class="form-group">
                      <label className='date-search-label mb-0 text-red'>To</label>
                      <input type="text" class="form-control form-control-border" placeholder="27 September 2022" />
                    </div>
                  </div>
                  <div className='col-sm-3 col-lg-2'>
                    <div><label className='date-search-label mb-0 text-red'>&nbsp;</label></div>
                    <button type="submit" className="btn btn-primary ">Search</button>
                  </div>
                </div>
              </div> */}

              {/* <div>
                <div className="row">
                  <div className="col-sm-6 col-md-4 col-lg-3">
                    <div className='dbox-outer'>
                      <div className='dbox-cols'>
                        <div className='pr-2 dbox-icon'><img src='../images/aeps-logo-2.svg' alt='icon' /></div>
                        <div className='dbox-text2'>
                          AepS <br />
                          ₹:  120000 <br />
                          Incentive:  12
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3">
                    <div className='dbox-outer'>
                      <div className='dbox-cols'>
                        <div className='pr-2 dbox-icon'><img src='../images/money-icon.svg' alt='icon' /></div>
                        <div className='dbox-text2'>
                          Money Transfer<br />
                          ₹:  120000<br />
                          Incentive:  12
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3">
                    <div className='dbox-outer'>
                      <div className='dbox-cols'>
                        <div className='pr-2 dbox-icon'><img src='../images/recharge-icon.svg' alt='icon' /></div>
                        <div className='dbox-text2'>
                          Recharge<br />
                          ₹:  1000<br />
                          Incentive:  10
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3">
                    <div className='dbox-outer'>
                      <div className='dbox-cols'>
                        <div className='pr-2 dbox-icon'><img src='../images/matm-icon.svg' alt='icon' /></div>
                        <div className='dbox-text2'>
                          MATM<br />
                          ₹:  800000<br />
                          Incentive:  55
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3">
                    <div className='dbox-outer'>
                      <div className='dbox-cols'>
                        <div className='pr-2 dbox-icon'><img src='../images/upiqr-icon.svg' alt='icon' /></div>
                        <div className='dbox-text2'>
                          UPI QR<br />
                          ₹:  120000<br />
                          Count:  12
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3">
                    <div className='dbox-outer'>
                      <div className='dbox-cols'>
                        <div className='pr-2 dbox-icon'><img src='../images/payment-gateway.svg' alt='icon' /></div>
                        <div className='dbox-text2'>
                          Payment Gateway<br />
                          ₹:
                          55000<br />
                          Count:  12
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3">
                    <div className='dbox-outer'>
                      <div className='dbox-cols'>
                        <div className='pr-2 dbox-icon'><img src='../images/money-icon.svg' alt='icon' /></div>
                        <div className='dbox-text2'>
                          Utility Payment<br />
                          ₹:  700<br />
                          Incentive:  1
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3">
                    <div className='dbox-outer'>
                      <div className='dbox-cols'>
                        <div className='pr-2 dbox-icon'><img src='../images/payment-gateway.svg' alt='icon' /></div>
                        <div className='dbox-text2'>
                          GTV Sales<br />
                          ₹:
                          300000<br />
                          Incentive:  55
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* Simple Custom Alert Modal */}
      {showAlert && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            maxWidth: '400px',
            textAlign: 'center',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}>
            <h6>
              SRPAY ID रजिस्ट्रेशन के लिए आपके पास DigiLocker अकाउंट होना चाहिए, जिसमें आपका आधार कार्ड और पैन कार्ड दोनों सत्यापित (verified) हों।
            </h6>
            <div style={{ marginTop: '20px' }}>
              <button
                onClick={handleConfirm}
                style={{
                  marginRight: '10px',
                  padding: '10px 20px',
                  backgroundColor: '#007bff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                OK
              </button>
              <button
                onClick={handleCancel}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}


export default DistributorDashboard;